;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ONE_SECOND_MS } from 'src/deprecated/constants/time'

/**
 *
 * @param dateInSeconds the date value returned from the server
 * @returns a formatted date string, e.g. 2020-06-06
 */
export const getDateString = (dateInSeconds: number) => {
  const dateInMilliseconds = dateInSeconds * ONE_SECOND_MS // The date is returned in seconds from the server
  return new Date(dateInMilliseconds).toISOString().split('T')[0]
}

/**
 *
 * @param dateInSeconds the date value returned from the server
 * @returns a date object
 */
export const getDate = (dateInSeconds: number) => {
  const dateInMilliseconds = dateInSeconds * ONE_SECOND_MS // The date is returned in seconds from the server
  return new Date(dateInMilliseconds)
}

/**
 * @description Get greeting based of time of day
 */
export const getTimeOfDayGreeting = (): string => {
  const currentHour = new Date().getHours()

  if (currentHour < 12) return 'Good morning'
  if (currentHour < 18) return 'Good afternoon'
  return 'Good evening'
}
